import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './policy-cancellation.actions';
import cloneDeep from 'clone-deep';

export interface State {
  rethinkingCheckboxInd: boolean;
  saleCheckboxInd: boolean;
  cancellationReasonDesc: string;
}

export const featureKey = 'flowDataPolicyCancellation';

export const initialState: State = {
  rethinkingCheckboxInd: null,
  saleCheckboxInd: null,
  cancellationReasonDesc: null,
};

export function policyCancellationReducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(Actions.UpdateRethinkingCheckbox, (state, { data }) => ({ ...state, rethinkingCheckboxInd: cloneDeep(data) })),
    on(Actions.UpdateSaleCheckbox, (state, { data }) => ({ ...state, saleCheckboxInd: cloneDeep(data) })),
    on(Actions.UpdatePolicyCancellationReasonDesc, (state, { data }) => ({
      ...state,
      cancellationReasonDesc: cloneDeep(data),
    }))
  )(state, action);
}
